import axios from 'axios';
import { isString, getOr } from 'lodash/fp';

export function getHeaders() {
  return {
    Accept: 'application/json',
    'Content-Type': 'application/json',
  };
}

export function requestService(url, data = {}) {
  if (!url || !isString(url)) {
    throw new Error('Required: url');
  }

  const { body, ...rest } = data;
  const options = {
    url: url,
    data: body,
    ...rest,
  };

  return axios
    .request(options)
    .then((response) => {
      return response.data;
    })
    .catch((error) => {
      throw new Error(getOr('Oops, something went wrong.', 'messages[0]')(error.response.data));
    });
}
